<template>
  <div class="payment-slot-wrapper">
    <slot :anyCheapPlan="anyCheapPlan" />
  </div>
</template>

<script>
import payment_mix from '@/mixins/payment_mix'

export default {
  name: 'PlaymentSlotWrapper',
  mixins: [payment_mix],
  props: {},
}
</script>
